export const InheritanceTemplateCode = Object.freeze({
  TEST_ZAV: "test_zav",
  SVID_PRAV_NA_NASLED_ZAVECHANIE: "SVID_PRAV_NA_NASLED_ZAVECHANIE",
});
